export const S_POS_MACHINE_TYPE_LIST_ACTION = "SAVE_POS_POS_MACHINE_TYPE_LIST_ACTIONS_ROLEACCESS"
export const S_POS_MACHINE_TYPE_LIST_SUCCESS = "S_POS_MACHINE_TYPE_LIST_SUCCESS"

export const S_POS_MACHINE_TYPE_SAVE_ACTION = "S_POS_MACHINE_TYPE_SAVE_ACTION"
export const S_POS_MACHINE_TYPE_SAVE_SUCCESS = "S_POS_MACHINE_TYPE_SAVE_SUCCESS"

export const S_POS_MACHINE_TYPE_API_ERROR_ACTION = "S_POS_MACHINE_TYPE_API_ERROR_ACTION"